import React, { useEffect, useState } from "react";
import { Table, Input, Tag, Space, Popconfirm, Select } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { ReactComponent as EditIcon } from "../../assets/edit-icon.svg";
import { ReactComponent as DeleteIcon } from "../../assets/delete-icon.svg";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "./redux/actions";
import SpinnerComponent from "../../components/spinner";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import CheckSvg from "../../assets/check.svg.png";
import CustomPagination from "../../components/customPagination/CustomPagination";
import AMultiSelect from "../../components/AMultiSelect";

const DocumentsTypesTable = ({ canUpdate }) => {
  const [sortedInfo, setSortedInfo] = useState(null);
  const [dataSource, setDataSource] = useState([]);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [currentDelRecord, setCurrentDelRecord] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(() => 1);
  const [resultPerPage, setResultPerPage] = useState(() => 10);
  const [req, setReq] = useState(false);
  const [search, setSearch] = useState({});
  const [defaultPageOneReq, setDefaultPageOneReq] = useState(false);
  const [revisionCheckedList, setRevisionCheckedList] = useState([]);
  const [distributionCheckedList, setDistributionCheckedList] = useState([]);
  const [sectionSearch, setSectionSearch] = useState(null);
  const [secDropDownOpen, setSecDropDownOpen] = useState(false);
  const [revDropDownOpen, setRevDropDownOpen] = useState(false);
  const [disDropDownOpen, setDisDropDownOpen] = useState(false);
  const { Option } = Select;

  const StatusOptions = [
    {
      label: "Yes",
      value: true,
    },
    {
      label: "No",
      value: false,
    },
  ];
  const SectionOptions = [
    {
      label: "IMS",
      value: "ims",
    },
    {
      label: "Project",
      value: "project",
    },
  ];
  const {
    allTemplates,
    fetchTemplateLoading,
    deleteTemplateLoading,
    totalRecords,
    revisionControl,
    distributionControl,
  } = useSelector((state) => state.docTypesReducer);

  const toTitleCase = (str) => {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  };

  useEffect(() => {
    if (page && resultPerPage && page > 0 && resultPerPage > 0) {
      dispatch(
        actions.fetchAllTemplates({
          page: page,
          per_page: resultPerPage,
          search,
          sort: sortedInfo?.order && sortedInfo?.columnKey,
          order: sortedInfo?.order
            ? sortedInfo?.order === "ascend"
              ? "asc"
              : "desc"
            : null,
        })
      );
    }
  }, [req]);

  useEffect(() => {
    let paramsPage = 1;
    if (paramsPage && resultPerPage && paramsPage > 0 && resultPerPage > 0) {
      dispatch(
        actions.fetchAllTemplates({
          page: paramsPage,
          per_page: resultPerPage,
          search,
        })
      );
      setPage(1);
    }
  }, [defaultPageOneReq]);

  useEffect(() => {
    debouncedCallApi();
  }, [sortedInfo]);

  const [debouncedCallApi] = useState(() =>
    _.debounce(() => setReq((prev) => !prev), 1000)
  );

  const [debouncedDefaultPageOneCallApi] = useState(() =>
    _.debounce(() => setDefaultPageOneReq((prev) => !prev), 1000)
  );
  useEffect(() => {
    setDataSource(allTemplates);
  }, [allTemplates]);

  useEffect(() => {
    setFetchLoading(fetchTemplateLoading);
  }, [fetchTemplateLoading]);

  const handleChange = (pagination, filter, sorter) => {
    if (secDropDownOpen || revDropDownOpen || disDropDownOpen) {
      return;
    }
    setSortedInfo(sorter);
  };

  const handleDelete = (record) => {
    setCurrentDelRecord(record);
    dispatch(actions.deleteTemplate(record));
  };

  const searchInput = (key) => (
    <Input
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => {
        setSearch({
          ...search,
          [key]: e.target.value,
        });
        debouncedDefaultPageOneCallApi();
      }}
    />
  );
  const handleSelectOnchange = (value, options, key, setHandler) => {
    if (value == undefined) {
      setHandler(null);
      handleMultiSelect("", key);
    } else {
      value = [value];
      if (value.includes("all")) {
        setHandler([...options.map((item) => item.value)]);
        value = options.map((item) => item.value);
      } else if (value.includes("not-all")) {
        setHandler([]);
        value = [];
      } else {
        setHandler(value);
      }
      handleMultiSelect(value, key);
    }
  };

  const handleSearchOnchange = (value, key, setHandler) => {
    if (value === undefined) {
      setHandler(null);
      handleMultiSelect("", key);
    } else {
      setHandler(value);
      handleMultiSelect(value, key);
    }
  };
  const handleMultiSelect = (list, key) => {
    setSearch({
      ...search,
      [key]: list,
    });
    debouncedCallApi();
  };
  const handleNavigate = (id) =>
    navigate(`/settings/document-types-manager/update-template/${id}`);

  const columns = [
    {
      title: () => {
        return (
          <div align="center" className="select-parent-div ">
            <div
              className="special-table-header-text columns-text"
              style={{ minHeight: "36px", height: "27px" }}
            >
              Section
            </div>
            <div className="li-div">
              <Select
                style={{
                  width: "100%",
                  minHeight: "25px",
                  fontSize: "12px",
                }}
                allowClear={true}
                readOnly={true}
                className="Select Project li-div"
                dropdownClassName="select-dropdown-custom"
                getPopupContainer={() =>
                  document.getElementsByClassName(
                    "ant-layout-content layout-content site-layout-background custom-textarea"
                  )[0]
                }
                showSearch
                placeholder=""
                optionFilterProp="children"
                onChange={(e) =>
                  handleSearchOnchange(e, "template_type", setSectionSearch)
                }
                onDropdownVisibleChange={(e) => {
                  setSecDropDownOpen(e);
                }}
                optionLabelProp="label"
                defaultValue={sectionSearch}
                value={sectionSearch}
                filterOption={(input, option) => {
                  let str = option?.children?.slice(
                    0,
                    option?.children?.length - 2
                  );
                  return str.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                }}
              >
                {SectionOptions?.map(({ label, value }) => {
                  return (
                    <Option value={value} label={label}>
                      {label || ""}
                    </Option>
                  );
                })}
              </Select>
            </div>
          </div>
        );
      },
      dataIndex: "template_type",
      key: "template_type",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "template_type" && sortedInfo?.order,
      ellipsis: true,
      width: "15%",
      render: (template_type, { id }) => (
        <div onClick={() => handleNavigate(id)}>
          {template_type === "ims"
            ? template_type.toUpperCase()
            : toTitleCase(template_type)}
        </div>
      ),
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div
              className="special-table-header-text"
              style={{ minHeight: "36px", height: "27px" }}
            >
              Template Name
            </div>
            <div>{searchInput("name")}</div>
          </div>
        );
      },
      dataIndex: "name",
      key: "name",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "name" && sortedInfo?.order,
      ellipsis: true,
      width: "20%",
      render: (name, { id }) => (
        <div onClick={() => handleNavigate(id)}>{name}</div>
      ),
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div
              className="special-table-header-text"
              style={{ minHeight: "36px" }}
            >
              Template Numbering Mask
            </div>
            <div>{searchInput("numbering_mask")}</div>
          </div>
        );
      },
      dataIndex: "numbering_mask",
      key: "numbering_mask",
      sorter: true,
      sortOrder:
        sortedInfo?.columnKey === "numbering_mask" && sortedInfo?.order,
      ellipsis: true,
      width: "20%",
      render: (numbering_mask, { id }) => (
        <div onClick={() => handleNavigate(id)}>{numbering_mask}</div>
      ),
    },
    {
      title: () => {
        return (
          <div align="center" className="select-parent-div">
            <div
              className="special-table-header-text"
              style={{ minHeight: "36px", justifyContent: "center" }}
            >
              TurnAround <br /> Time (Days)
            </div>
            <div>{searchInput("completion_days")}</div>
          </div>
        );
      },
      dataIndex: "completion_days",
      key: "completion_days",
      sorter: true,
      sortOrder:
        sortedInfo?.columnKey === "completion_days" && sortedInfo?.order,
      width: "10%",
      align: "center",
      render: (completion_days, { id }) => (
        <div
          style={{
            textAlign: "top",
          }}
          onClick={() => handleNavigate(id)}
        >
          {completion_days}
        </div>
      ),
    },
    {
      title: () => {
        return (
          <div align="center" className="select-parent-div ">
            <div
              className="special-table-header-text columns-text"
              style={{
                minHeight: "32px",
                justifyContent: "center",
                height: "25px",
              }}
            >
              Revision <br /> Control
            </div>
            <div className="li-div">
              <Select
                style={{
                  width: "100%",
                  minHeight: "25px",
                  fontSize: "12px",
                }}
                allowClear={true}
                readOnly={true}
                className="Select Project"
                dropdownClassName="select-dropdown-custom"
                getPopupContainer={() =>
                  document.getElementsByClassName(
                    "ant-layout-content layout-content site-layout-background custom-textarea"
                  )[0]
                }
                onDropdownVisibleChange={(e) => {
                  setDisDropDownOpen(e);
                }}
                showSearch
                placeholder=""
                optionFilterProp="children"
                onClick={(e) => e.stopPropagation()}
                onChange={(e) =>
                  handleSelectOnchange(
                    e,
                    revisionControl,
                    "revision_control",
                    setRevisionCheckedList
                  )
                }
                optionLabelProp="label"
                defaultValue={revisionCheckedList}
                value={revisionCheckedList}
                filterOption={(input, option) => {
                  let str = option?.children?.slice(
                    0,
                    option?.children?.length - 2
                  );
                  return str.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                }}
              >
                {StatusOptions?.map(({ label, value }) => {
                  return (
                    <Option value={value} label={label}>
                      {label || ""}
                    </Option>
                  );
                })}
              </Select>
            </div>
          </div>
        );
      },
      dataIndex: "revision_control",
      key: "revision_control",
      sorter: true,
      sortOrder:
        sortedInfo?.columnKey === "revision_control" && sortedInfo?.order,
      width: "10%",
      render: (revision_control) => {
        if (revision_control === null) {
          return;
        }
        return (
          <div
            style={{
              textAlign: "center",
              width: "100%",
            }}
          >
            {" "}
            {revision_control && <img alt="" src={CheckSvg} />}
          </div>
        );
      },
    },
    {
      title: () => {
        return (
          <div align="center" className="select-parent-div ">
            <div
              className="special-table-header-text columns-text"
              style={{
                minHeight: "32px",
                justifyContent: "center",
                height: "25px",
              }}
            >
              Distribution <br /> Control
            </div>
            <div>
              <Select
                style={{
                  width: "100%",
                  minHeight: "25px",
                  fontSize: "12px",
                }}
                onClick={(e) => e.stopPropagation()}
                allowClear={true}
                readOnly={true}
                className="Select Project"
                dropdownClassName="select-dropdown-custom"
                getPopupContainer={() =>
                  document.getElementsByClassName(
                    "ant-layout-content layout-content site-layout-background custom-textarea"
                  )[0]
                }
                onDropdownVisibleChange={(e) => {
                  setDisDropDownOpen(e);
                }}
                showSearch
                placeholder=""
                optionFilterProp="children"
                onChange={(e) =>
                  handleSelectOnchange(
                    e,
                    distributionControl,
                    "distribution_control",
                    setDistributionCheckedList
                  )
                }
                optionLabelProp="label"
                defaultValue={distributionCheckedList}
                value={distributionCheckedList}
                filterOption={(input, option) => {
                  let str = option?.children?.slice(
                    0,
                    option?.children?.length - 2
                  );
                  return str.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                }}
              >
                {StatusOptions?.map(({ label, value }) => {
                  return (
                    <Option value={value} label={label}>
                      {label || ""}
                    </Option>
                  );
                })}
              </Select>
            </div>
          </div>
        );
      },
      dataIndex: "distribution_control",
      key: "distribution_control",
      sorter: true,
      sortOrder:
        sortedInfo?.columnKey === "distribution_control" && sortedInfo?.order,
      width: "10%",
      render: (distribution_control) => {
        if (distribution_control === null) {
          return;
        }
        return (
          <div
            style={{
              textAlign: "center",
              width: "100%",
            }}
          >
            {" "}
            {distribution_control && <img alt="" src={CheckSvg} />}
          </div>
        );
      },
    },
    {
      title: null,
      dataIndex: "",
      key: "action",
      width: "10%",
      align: "center",
      render: (_, record) => {
        if (!canUpdate) {
          return;
        }

        return deleteTemplateLoading && record.id === currentDelRecord.id ? (
          <SpinnerComponent fontSize={14} />
        ) : (
          <Space size={15} align="baseline">
            <EditIcon
              width={18}
              height={18}
              className="custom-icon"
              onClick={() => {
                handleNavigate(record.id);
                dispatch(actions.setDocumentTemplateIsEdit(true));
              }}
            />
            <Popconfirm
              title="Are you sure you want to delete this Template?"
              placement="topRight"
              onConfirm={() => handleDelete(record)}
              okText="Yes"
              cancelText="No"
            >
              <DeleteIcon width={18} height={18} className="custom-icon" />
            </Popconfirm>
          </Space>
        );
      },
    },
  ];

  return (
    <>
      <div className="table-main-div-holder">
        <Table
          className="special-table doc-type-table"
          columns={columns}
          scroll={{ x: !fetchTemplateLoading }}
          onChange={handleChange}
          dataSource={dataSource}
          pagination={false}
          sortUpIcon={<UpOutlined />}
          sortDownIcon={<DownOutlined />}
          loading={fetchTemplateLoading}
        />
      </div>
      <CustomPagination
        page={page}
        setPage={setPage}
        resultPerPage={resultPerPage}
        setResultPerPage={setResultPerPage}
        debouncedCallApi={debouncedCallApi}
        totalRecord={totalRecords}
      />
    </>
  );
};
export default DocumentsTypesTable;
